import React, { useState, useEffect } from 'react';

import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fundo from "../../../../styles/fundo.svg";


const FormContainer = styled.form`
  width: 300px;

  background-color: rgba(255, 255, 255, 0.8);
  justify-content: center; 
  display: flex; 
  padding: 5px 10px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 1px;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  


`;

const Container = styled.div`
  width: 300px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  text-align: start;
  gap: 10px;
  padding: 0px 10px; 
  height: auto;


`;

const Div3 = styled.div`
  width: 100%;
`;

const Div2 = styled.div`
  padding-top: 30px;
`;

const Div = styled.div`
  padding-top: 20px;
`;

const Input = styled.input`
  font-family: "Open Sans", sans-serif;
  width: 94%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #076633;
  }
`;

const Label = styled.label`

  padding-top: 25px;
  font-weight: bold;
  font-size: 17px;
  text-align: left;
  color: #575757;
  p{
    color: #575757;
  }
  

`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;

`;


const Button = styled.button`
  width: auto;
  padding: 10px;
  margin: 10px 0;
  background-color: #a5adb0;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-image: url(${fundo});
  }
`;





function Login({ urlApi, modalSenha, acessos }) {


  const [login, setLogin] = useState(acessos?.[0]?.LOGON || '');

  const [senha, setSenha] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [novaSenhaNovamente, setNovaSenhaNovamente] = useState('');
  const [isButtonVisible, setIsButtonVisible] = useState(false);


  // Função de login

  const handleLogin = async () => {

    if (novaSenha !== novaSenhaNovamente) {
      return toast.error("As novas senhas não coincidem!");
    }

    if (!novaSenha || !novaSenhaNovamente) {
      return toast.error("Os campos de senha não podem estar vazios!");
    }

    try {

      const response = await fetch(`${urlApi}logon/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login: login.toLowerCase(),
          senha,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        await axios
          .put(`${urlApi}logon/trocar-senha/${login}`, {

            senha: novaSenha,
          })
          .then(async ({ data }) => {
            toast.success(data.mensagem);

          })
          .catch((error) => {
            if (error.response) {
              const errorMessage = error.response.data.error || 'Erro desconhecido';
              toast.error("Erro ao editar: " + errorMessage);
            } else {
              toast.error('Erro inesperado.');
            }
          });

        setTimeout(function () {
          modalSenha();
        }, 1500);

      } else {
        toast.error(data.error || 'Erro desconhecido no login.');


      }
    } catch (error) {
      alert('Erro de rede ou erro desconhecido.');

      // Salvar log de falha de rede no banco de dados

    }
  };



  useEffect(() => {
    // Verifica se todos os campos estão preenchidos
    if (login && senha && novaSenha && novaSenhaNovamente) {
      setIsButtonVisible(true);
    } else {
      setIsButtonVisible(false);
    }
  }, [login, senha, novaSenha, novaSenhaNovamente]);






  return (
    <FormContainer >
      <Container>
        <Div2>
          <Div>
            <Label>Usuário:</Label>
            <Input
              type="text"
              placeholder="Digite aqui..."
              value={login}
              onChange={(e) => setLogin(e.target.value)}

            />

          </Div>
          <Div>
            <Label>Senha:</Label>
            <Input
              type="password"
              placeholder="Digite aqui..."
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
            />
          </Div>

        </Div2>

        <Div2>
          <Div>
            <Label>Nova Senha:</Label>

            <Input
              type="password"
              placeholder="Digite aqui..."
              onChange={(e) => setNovaSenha(e.target.value)}
            />
          </Div>
          <Div>
            <Label>Repetir nova senha:</Label>
            <Input
              type="password"
              placeholder="Digite aqui..."
              onChange={(e) => setNovaSenhaNovamente(e.target.value)}
            />
          </Div>

        </Div2>


        <Div3>
          <ContainerButton>
            {isButtonVisible && (
              <Button type="button" onClick={handleLogin}>
                Trocar a senha
              </Button>
            )}
          </ContainerButton>
        </Div3>

      </Container>
    </FormContainer>
  );
}

export default Login;

